import { DateTime } from 'luxon';
import { INPUT_DATE } from './formats';

export const fromJSDateToInputDate = (date: Date): string => {
    return DateTime.fromJSDate(date).toFormat(INPUT_DATE);
};
